import React from 'react';
import {Field, reduxForm} from 'redux-form';
import ValidatedInputField from '../common/form/ValidatedInputField';
import {validateGalleryImage} from './validateGalleryImage.js';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import afterSubmitFail from '../common/form/focusAfterSubmitFail';
import ResetButton from "../common/ResetButton";

let GalleryImageForm = props => {

    const {
        handleSubmit,
        handleReset,
        isUpdating,
        isUpdate,
        handleSelectedFile,
        fileErrorMessages,
        defaultImageProps,
        intl
    } = props;

    return (
        <form onSubmit={handleSubmit} noValidate={true}>
            <Field
                type="text"
                name="description"
                component={ValidatedInputField}
                placeholder={intl.formatMessage(messages.descriptionPlaceholder)}
                className="form-control"
                label={intl.formatMessage(messages.description)}
            />
            <div className={`form-group row ${fileErrorMessages.length > 0 ? 'has-danger' : ''}`}>
                <label className="col-form-label col-sm-2">
                    JPEG eller PNG<br />
                    Bredde ≤ {defaultImageProps.maxWidth} px<br />
                    Højde ≤ {defaultImageProps.maxHeight} px<br />
                    Størrelse ≤ {defaultImageProps.maxWeight} Mb<br />
                </label>
                <div className="col-md-10">
                    <input
                        type="file"
                        accept={defaultImageProps.mimeType}
                        multiple={false}
                        onChange={handleSelectedFile}
                        className="form-control-file"
                    />
                    {
                        (fileErrorMessages.length > 0) &&
                        <div className="form-control-feedback error-block">
                            {
                                fileErrorMessages.map((error, index) => {
                                    return <div key={index}>{error}</div>
                                })
                            }
                        </div>
                    }
                </div>
            </div>
            <hr/>
            <div className="form-group row">
                <div className="col-sm-12">
                    <div className="offset-sm-2">
                        {
                            !isUpdating &&
                            <button
                                onClick={handleSubmit}
                                className="btn btn-primary waves-effect list-create-button">
                                {isUpdate() ? 'Opdater' : 'Gem'}
                            </button>
                        }

                        {
                            isUpdating &&
                            <button disabled type="submit" className={`disabled btn btn-primary waves-effect list-create-button`}>
                                <i className="fa fa-spin fa-spinner"/> Arbejder...
                            </button>
                        }
                        <ResetButton onClick={handleReset}/>
                    </div>
                </div>
            </div>

        </form>
    );
};

GalleryImageForm = reduxForm({
    form: 'galleryImageForm',
    validate: validateGalleryImage,
    onSubmitFail: afterSubmitFail
})(GalleryImageForm);

export default injectIntl(GalleryImageForm);


// WEBPACK FOOTER //
// ./web/src/components/galleries/GalleryImageForm.jsx